// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__mpfM-","visible":"Overlay_visible__MNCxp","fadeIn":"Overlay_fadeIn__D74oc","hidden":"Overlay_hidden__3J0z0","fadeOut":"Overlay_fadeOut__zH1Ad"};